import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { TrackingView } from '@components/TrackingView';
import { getImageSrc } from '@utils/getImageSrc';
import { ArrowUpIcon } from '@gemini/icons';
import { HOUSE_VALUE_LANDING_PAGE_LAYOUT_TEST_ID } from '@utils/constants';
import HeroCard from '@components/HeroCard';
import Content from '@components/Content';
import Experts from '@components/Experts';
import SeoLinks from '@components/SeoLinks';
import ScrollToTheTop from '@components/ScrollToTheTop';
export const Layout = () => {
    const backgroundImageUrl = (device) => {
        if (device === 'desktop') {
            return `url('${getImageSrc('hero_large.jpg')}')`;
        }
        else {
            return `url('${getImageSrc('hero_small.jpg')}')`;
        }
    };
    return (_jsxs(Box, { as: "main", testId: HOUSE_VALUE_LANDING_PAGE_LAYOUT_TEST_ID, marginTop: { 'breakpoint.lg': 'spacing.32' }, marginHorizontal: {
            'breakpoint.lg': 'spacing.32',
        }, children: [_jsx(Box, { as: "div", height: { 'breakpoint.base': '284px', 'breakpoint.lg': '444px' }, backgroundImage: {
                    'breakpoint.base': backgroundImageUrl('mobile'),
                    'breakpoint.lg': backgroundImageUrl('desktop'),
                }, backgroundSize: {
                    'breakpoint.base': 'cover',
                    'breakpoint.lg': 'auto 444px',
                }, backgroundPosition: {
                    'breakpoint.base': 'center',
                    'breakpoint.lg': 'right top',
                }, borderRadius: { 'breakpoint.lg': 'radius.16' }, unsafe_style: { backgroundColor: '#ded7cd' } }), _jsxs(Box, { as: "div", display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent: { 'breakpoint.lg': 'center' }, paddingBottom: "spacing.48", paddingHorizontal: {
                    'breakpoint.base': 'spacing.16',
                    'breakpoint.md': 'spacing.32',
                }, marginTop: {
                    'breakpoint.base': '-164px',
                    'breakpoint.sm': '-140px',
                    'breakpoint.lg': '-350px',
                }, children: [_jsx(HeroCard, { title: 'Verkehrswert Immobilie: So ermittelst du ihn richtig', bulletPoints: [
                            '100% kostenlos',
                            'Monatliche Updates per E-Mail',
                            'Werteinschätzung in 3 Minuten',
                        ] }), _jsxs(Box, { as: "div", width: "100%", maxWidth: "676px", children: [_jsx(Content, {}), _jsx(Experts, {}), _jsx(SeoLinks, { title: "Die passende Anzeige f\u00FCr jedes deiner Vorhaben." })] }), _jsx(TrackingView, {})] }), _jsx(ScrollToTheTop, { text: 'Bewertung starten', icon: _jsx(ArrowUpIcon, {}) })] }));
};
